import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoaurangabadtempotraveller() {



  const cardData =
  {
    keyword: 'Pune to Aurangabad Tempo Traveller on Rent ',
    heading: 'Sanavi Travels: Pune to Aurangabad Tempo Traveller on Rent',
    headingDescription: 'Sanavi Travels offers reliable Pune to Aurangabad Tempo Traveller on Rent, providing safe, comfortable, and hassle-free travel solutions for families, corporate groups, pilgrims, tourists, and friends traveling from Pune to Aurangabad. Our fleet of 9, 12, 13, 14, 17, and 26 seater tempo travellers is well-maintained and designed for long-distance comfort with spacious seating, push-back seats, ample legroom, and sufficient luggage space. With experienced chauffeurs, flexible one-way and round-trip rental options, transparent pricing, and 24/7 booking support, Sanavi Travels ensures a smooth and punctual journey. We offer convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering popular Aurangabad attractions such as Ajanta Caves, Ellora Caves, Bibi Ka Maqbara, Daulatabad Fort, and Grishneshwar Temple. Choose Sanavi Travels for dependable Pune to Aurangabad tempo traveller rental services, delivering comfort, safety, and a memorable travel experience.',

    top: 'Top Places to Visit in Aurangabad with Sanavi Travels',


"topPlaces": [
  {
    "title": "Ajanta Caves",
    "description": "Ajanta Caves are a UNESCO World Heritage Site and one of the finest examples of ancient Indian rock-cut architecture. Dating back to the 2nd century BCE, the caves are renowned for their exquisite Buddhist murals and sculptures depicting the life of Buddha. Carved into a horseshoe-shaped cliff, the caves showcase remarkable artistry and storytelling. Ajanta stands as a timeless treasure of Indian art, history, and spiritual heritage."
  },
  {
    "title": "Ellora Caves",
    "description": "Ellora Caves, another UNESCO World Heritage Site, represent a unique blend of Buddhist, Hindu, and Jain rock-cut architecture. The highlight is the Kailasa Temple, a massive monolithic structure carved from a single rock. Dating from the 6th to 10th centuries, the caves symbolize religious harmony and architectural brilliance. Ellora is one of India’s most awe-inspiring historical sites."
  },
  {
    "title": "Bibi Ka Maqbara",
    "description": "Bibi Ka Maqbara is a stunning Mughal-era monument often referred to as the ‘Taj of the Deccan’. Built by Aurangzeb’s son in memory of his mother, it features elegant marble domes, intricate carvings, and symmetrical gardens. The monument reflects Mughal architectural grace at a smaller scale. It is Aurangabad’s most iconic landmark and a major tourist attraction."
  },
  {
    "title": "Daulatabad Fort",
    "description": "Daulatabad Fort, formerly known as Devagiri, is a massive hilltop fortress known for its advanced defense systems. The fort features moats, secret passages, steep staircases, and the famous Chand Minar. Once the capital of the Tughlaq dynasty, it offers panoramic views of the surrounding landscape. Daulatabad Fort stands as a symbol of medieval military engineering and strategic brilliance."
  },
  {
    "title": "Grishneshwar Jyotirlinga Temple",
    "description": "Grishneshwar Temple is one of the twelve Jyotirlingas of Lord Shiva and a highly revered pilgrimage site. Built in traditional stone architecture, the temple is located near Ellora Caves. Devotees visit for spiritual blessings and religious rituals. Grishneshwar represents Aurangabad’s deep spiritual significance and divine heritage."
  },
  {
    "title": "Panchakki",
    "description": "Panchakki is a historic water mill that showcases ancient hydraulic engineering used to grind grain. It is associated with the Dargah of Baba Shah Musafir and features a peaceful garden setting. The flowing water channels create a calm and scenic environment. Panchakki reflects Aurangabad’s blend of innovation, history, and spirituality."
  },
  {
    "title": "Aurangabad Caves",
    "description": "Aurangabad Caves are lesser-known Buddhist rock-cut caves dating back to the 6th and 7th centuries. Carved into a hillside, they feature intricate sculptures and artistic carvings. The caves offer panoramic views of the city below. Aurangabad Caves provide a quieter and more intimate glimpse into ancient Buddhist art."
  },
  {
    "title": "Salim Ali Lake",
    "description": "Salim Ali Lake is a scenic freshwater lake named after the famous ornithologist Dr. Salim Ali. It is a popular spot for birdwatching, morning walks, and relaxation. The lake offers a peaceful escape from city life. Salim Ali Lake adds natural charm to Aurangabad’s historical landscape."
  },
  {
    "title": "Himayat Bagh",
    "description": "Himayat Bagh is a historic Mughal garden established during the reign of Aurangzeb. It features fruit orchards, walking paths, and a serene environment. The garden once served as an agricultural research center. Himayat Bagh reflects the Mughal legacy of landscape design and leisure."
  },
  {
    "title": "Siddharth Garden and Zoo",
    "description": "Siddharth Garden and Zoo is a popular family attraction featuring landscaped gardens and a small zoo. It houses various animals, birds, and reptiles, along with a musical fountain. The garden provides recreational space for visitors of all ages. It is a refreshing spot for leisure and relaxation in Aurangabad."
  }
]
,





"services": [
    {
      "name": "Pune to Aurangabad Tempo Traveller on Rent",
      "description": "Pune to Aurangabad Tempo Traveller on Rent provides comfortable and reliable vehicles for group travel between Pune and Aurangabad. Ideal for families, friends, and corporate groups, these vehicles ensure spacious seating, luggage-friendly interiors, and professional drivers. Perfect for long-distance journeys, sightseeing tours, or weekend getaways, this service emphasizes safety, punctuality, and a hassle-free travel experience."
    },
    {
      "name": "Aurangabad Tempo Traveller Hire from Pune",
      "description": "Aurangabad Tempo Traveller Hire from Pune offers flexible rental options for short or long trips to Aurangabad. Well-maintained vehicles, experienced drivers, and customizable travel plans ensure a safe, comfortable, and convenient journey. Suitable for family outings, corporate trips, and group excursions."
    },
    {
      "name": "AC Tempo Traveller Pune to Aurangabad",
      "description": "AC Tempo Traveller Pune to Aurangabad provides air-conditioned vehicles for a cool and comfortable ride over long distances. Spacious interiors, luggage space, and professional chauffeurs make it ideal for families, friends, and corporate travelers seeking a stress-free journey from Pune to Aurangabad."
    },
    {
      "name": "Luxury Tempo Traveller Aurangabad Trip",
      "description": "Luxury Tempo Traveller Aurangabad Trip offers premium, well-appointed vehicles for an elegant and comfortable travel experience. Ideal for VIP trips, weddings, corporate travel, or special family outings, these vehicles provide reclining seats, entertainment options, and ample luggage space with professional drivers ensuring timely and safe transfers."
    },
    {
      "name": "Family Tempo Traveller Aurangabad",
      "description": "Family Tempo Traveller Aurangabad ensures safe and comfortable travel for families visiting Aurangabad. Vehicles provide ample seating, luggage space, and child-friendly features, making it perfect for weekend trips, sightseeing tours, or multi-day family vacations with stress-free transport."
    },
    {
      "name": "Corporate Tempo Traveller Aurangabad",
      "description": "Corporate Tempo Traveller Aurangabad caters to office groups and business travelers commuting between Pune and Aurangabad. Vehicles offer spacious seating, premium interiors, and onboard amenities. Professional chauffeurs maintain punctuality and safety, allowing employees to relax or work during the journey."
    },
    {
      "name": "Affordable Tempo Traveller Aurangabad",
      "description": "Affordable Tempo Traveller Aurangabad provides budget-friendly travel options without compromising comfort or safety. Well-maintained vehicles, spacious interiors, and skilled drivers make it ideal for families, friends, or corporate groups seeking economical travel solutions from Pune to Aurangabad."
    },
    {
      "name": "Chauffeur Driven Tempo Traveller Aurangabad",
      "description": "Chauffeur Driven Tempo Traveller Aurangabad offers professional drivers for a stress-free journey. Passengers can relax while experienced chauffeurs manage routes and traffic, ensuring punctuality and safety for family trips, corporate travel, or group excursions from Pune to Aurangabad."
    },
    {
      "name": "Group Travel Tempo Traveller Aurangabad",
      "description": "Group Travel Tempo Traveller Aurangabad caters to large groups traveling from Pune. Spacious vehicles with comfortable seating, luggage-friendly interiors, and professional drivers ensure a smooth and enjoyable experience for sightseeing, weekend trips, or corporate travel."
    },
    {
      "name": "Best Tempo Traveller Pune to Aurangabad",
      "description": "Best Tempo Traveller Pune to Aurangabad provides top-quality vehicles and exceptional service for a superior travel experience. Comfortable seating, safe driving, and attention to passenger convenience make it ideal for families, friends, and corporate travelers seeking reliable and punctual transport."
    },
    {
      "name": "Pune Aurangabad Travel Vehicle",
      "description": "Pune Aurangabad Travel Vehicle offers dependable and well-maintained vehicles for groups traveling between Pune and Aurangabad. Spacious interiors, skilled chauffeurs, and luggage-friendly features ensure a safe and smooth journey, perfect for weekend trips, sightseeing, or corporate travel."
    },
    {
      "name": "Tourist Tempo Traveller Aurangabad",
      "description": "Tourist Tempo Traveller Aurangabad provides vehicles for sightseeing and group tours around Aurangabad. Comfortable seating, reliable drivers, and luggage-friendly interiors make it ideal for visiting tourist attractions, historical sites, and cultural spots with ease and convenience."
    },
    {
      "name": "Weekend Trip Tempo Traveller",
      "description": "Weekend Trip Tempo Traveller offers vehicles specifically for short weekend trips from Pune to Aurangabad. Spacious interiors, professional drivers, and reliable service ensure a hassle-free journey for families, friends, or corporate groups looking for a quick getaway."
    },
    {
      "name": "Tempo Traveller Rental Service Pune",
      "description": "Tempo Traveller Rental Service Pune provides dependable rental vehicles for trips to Aurangabad. Well-maintained interiors, professional chauffeurs, and flexible booking options make it convenient for all types of travelers, ensuring comfort and safety throughout the journey."
    },
    {
      "name": "Aurangabad Tour Tempo Traveller",
      "description": "Aurangabad Tour Tempo Traveller offers reliable vehicles for sightseeing and tour packages in Aurangabad. Spacious, comfortable, and well-equipped, these vehicles ensure safe, convenient, and enjoyable travel for families, friends, and corporate groups exploring the city and nearby attractions."
    }
  ],
  "tableData": [
    ["Pune to Aurangabad Tempo Traveller on Rent", "Aurangabad Tempo Traveller Hire from Pune"],
    ["AC Tempo Traveller Pune to Aurangabad", "Luxury Tempo Traveller Aurangabad Trip"],
    ["Family Tempo Traveller Aurangabad", "Corporate Tempo Traveller Aurangabad"],
    ["Affordable Tempo Traveller Aurangabad", "Chauffeur Driven Tempo Traveller Aurangabad"],
    ["Group Travel Tempo Traveller Aurangabad", "Best Tempo Traveller Pune to Aurangabad"],
    ["Pune Aurangabad Travel Vehicle", "Tourist Tempo Traveller Aurangabad"],
    ["Weekend Trip Tempo Traveller", "Tempo Traveller Rental Service Pune"],
    ["Aurangabad Tour Tempo Traveller", "—"]
  ]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Aurangabad Tempo Traveller on Rent with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides reliable and comfortable Pune to Aurangabad Tempo Traveller rental services, ideal for group travel, sightseeing tours, and airport transfers."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in air-conditioned, well-serviced Tempo Travellers with ample seating and luggage space for a smooth and relaxing journey from Pune to Aurangabad."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Pune-Aurangabad Route",
    "WhyChoosedescription": "Our professional drivers are familiar with Pune to Aurangabad routes, ensuring safe, timely, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear pricing including fuel, tolls, and driver allowances, making your Pune to Aurangabad trip stress-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our team is available round the clock to assist with bookings, travel inquiries, and schedule updates."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized rental plans tailored for your Pune to Aurangabad travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All Tempo Travellers are thoroughly cleaned and sanitized before every trip to ensure passenger safety and hygiene."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making your journey from Pune to Aurangabad smooth and comfortable."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide Tempo Traveller on rent from Pune to Aurangabad?',
    answer: 'Yes, Sanavi Travels offers well-maintained and comfortable Tempo Travellers for travel from Pune to Aurangabad.'
  },
  {
    question: 'How can I book a Pune to Aurangabad Tempo Traveller with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of Tempo Travellers are available for Pune to Aurangabad travel?',
    answer: 'We provide 9-seater, 12-seater, 13-seater, and 17-seater Tempo Travellers suitable for groups of any size.'
  },
  {
    question: 'Are drivers included in the Tempo Traveller rental?',
    answer: 'Yes, all rentals include experienced and professional drivers familiar with the Pune-Aurangabad route.'
  },
  {
    question: 'Is the service available 24x7?',
    answer: 'Yes, Sanavi Travels provides round-the-clock service for bookings and travel.'
  },
  {
    question: 'Are the vehicles sanitized before trips?',
    answer: 'Yes, all Tempo Travellers are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I customize the rental plan for Pune to Aurangabad travel?',
    answer: 'Absolutely. Sanavi Travels offers customized rental plans according to your travel requirements.'
  },
  {
    question: 'What payment options are available for booking a Tempo Traveller?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Aurangabad trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Arjun Deshmukh',
    feedback: 'Booked a Tempo Traveller from Pune to Aurangabad with Sanavi Travels. Very comfortable, clean, and the driver was professional. Highly recommended!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priya Patil',
    feedback: 'Excellent service! Smooth journey, punctual pickup, and well-maintained vehicle made our Pune to Aurangabad trip enjoyable.',
    rating: 5
  }
];







































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];






const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Aurangabad Tempo Traveller on Rent - Sanavi Travels",
  "description": "Tempo Traveller on rent from Pune to Aurangabad by Sanavi Travels for family trips, corporate travel, weekend getaways, and tourist visits. Choose AC and luxury Tempo Travellers for safe, comfortable, and affordable long-distance travel.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1850"
  }
};










  return (
    <div>

<Helmet>
  <title>
    Pune to Aurangabad Tempo Traveller on Rent Starting from ₹38 Per Km | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Tempo Travellers from Pune to Aurangabad with Sanavi Travels. AC and luxury Tempo Travellers for family trips, corporate travel, weekend getaways, and tourist visits at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/26.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoaurangabadtempotraveller;